import window from "global/window"
import Catalina from "./components/Catalina"

const query = require("./utils/queryString")

if (query.parse() && query.isValid()) {
  const cat = new Catalina({
    td: {
      database: query.getDatabase()
    },
    cmp: {
      ci: query.getCmpCi(),
      t: query.getCmpT()
    }
  })

  cat.track(query.getTable(), {
    partner_id: query.getPartnerId(),
    campaign_id: query.getCampaignId(),
    member_id: query.getMemberId(),
    adid: query.getAdid(),
    idfa: query.getIdfa(),
    pin: query.getPin()
  })
}

// Expose the library on the window
window.Catalina = Catalina
